
























































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio, Select, SwitchToggle } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

// models
import { PropOptionSelect } from '@/models'
import { SubAreaForm, AreaModel } from '@/models/config'

// constants
import { optionsStatus } from '@/constants'

// utils
import { loading, alerts } from '@/utils'

// services
import { SubAreaService, AreaService } from '@/services/config'

@Component({
    name: 'FormCreateEditSubArea',
    components: {
        Input,
        Radio,
        Select,
        SwitchToggle
    },
    mixins: [validationMixin]
})
export default class FormCreateEditSubArea extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) subArea!: SubAreaForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    areas: AreaModel[]|[] = []
    form: SubAreaForm = {
        name: '',
        area_id: null,
        description: '',
        is_active: true,
        is_group_piecework: false
    }

    created () {
        this.getAreasAcctivated()
        if (this.idEdit) {
            this.form = this.subArea
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                name: { required, minLength: minLength(2) },
                area_id: { required },
                description: { required },
                is_active: { required }
            }
        }
    }

    async getAreasAcctivated () {
        this.areas = await AreaService.getActivated()
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await SubAreaService.update(this.idEdit, this.form)
                } else {
                    await SubAreaService.create(this.form)
                }
                alerts.success()
                this.$v.$reset()
                this.form = {
                    name: '',
                    area_id: null,
                    description: '',
                    is_active: true,
                    is_group_piecework: false
                }
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }

    get areasOptions (): PropOptionSelect[] {
        const areas: PropOptionSelect[] = []
        this.areas.forEach(area => {
            if (area.id) {
                areas.push({
                    text: area.name,
                    value: area.id
                })
            }
        })
        return areas
    }
}
